<template>
    <div>
        <sui-loader :active="isLoading" centered />

        <Paginator :current.sync="pagination.page" :total="total" :size="pagination.pageSize" />

        <sui-table class="compact" celled striped>
            <sui-table-header>
                <sui-table-row>
                    <sui-table-header-cell v-if="!isExcluded('ID')">ID</sui-table-header-cell>
                    <sui-table-header-cell v-if="!isExcluded('ID Sage')">Sage ID</sui-table-header-cell>
                    <sui-table-header-cell v-if="!isExcluded('Code Visibble')">Code Visibble</sui-table-header-cell>
                    <sui-table-header-cell v-if="!isExcluded('Nom')">{{ $t('common.name') }}</sui-table-header-cell>
                    <sui-table-header-cell v-if="!isExcluded('Tags')">Tags</sui-table-header-cell>
                    <sui-table-header-cell :width="1" v-if="!isExcluded('Actions')">{{ $t('common.actions') }}</sui-table-header-cell>
                </sui-table-row>
            </sui-table-header>

            <!-- Table Body -->

            <sui-table-body v-if="isLoading === false">

                <sui-table-row v-for="customer in customers" :key="customer.id">
                    <sui-table-cell v-if="!isExcluded('ID')">{{ customer.id }}</sui-table-cell>
                    <sui-table-cell v-if="!isExcluded('ID Sage')">{{ customer.sage_id }}</sui-table-cell>
                    <sui-table-cell text-align="center" v-if="!isExcluded('Code Visibble')">
                        <sui-button class="tiny"
                                    icon="paste"
                                    v-clipboard:copy="customer.customer_code"
                                    v-clipboard:error="onCopyCustomerCodeError"
                                    v-clipboard:success="onCopyCustomerCodeSuccess"></sui-button>
                    </sui-table-cell>
                    <sui-table-cell v-if="!isExcluded('Name')">{{ customer.name }}</sui-table-cell>
                    <sui-table-cell v-if="!isExcluded('Tags')">
                        <div class="wrap">
                            <TagPill
                                v-for="tag in customer.tag_ids" :key="tag"
                                v-bind:tag-id="tag"
                                v-bind:tag-collection="tags"
                            />
                        </div>
                    </sui-table-cell>
                    <sui-table-cell text-align="center" v-if="!isExcluded('Actions')">
                        <slot name="actions" :customer="customer" />
                    </sui-table-cell>
                </sui-table-row>

            </sui-table-body>
        </sui-table>

        <Paginator :current.sync="pagination.page" :total="total" :size="pagination.pageSize" />
    </div>
</template>

<script>
import TagPill from '@/components/tag/TagPill.vue';
import Paginator from '@/components/Paginator.vue';
import { api } from '@/api';

export default {
    components: {
        TagPill,
        Paginator,
    },

    props: {
        query: {
            type: Object,
            required: true,
        },
        excludeColumns: {
            type: Array,
            default: () => [],
        },
    },

    data() {
        return {
            isLoading: false,
            tags: [],
            filter_tags: [],
            customers: [],
            total: 0,
            pagination: {
                page: 1,
                pageSize: 50,
            },
        };
    },

    watch: {
        query: {
            handler() {
                if (this.pagination.page === 1) {
                    this.getCustomers();
                } else {
                    this.pagination.page = 1;
                }
            },
            immediate: true,
            deep: true,
        },
        pagination: {
            handler() {
                this.$emit('paginationChange', this.pagination);
                this.getCustomers();
            },
            immediate: false,
            deep: true,
        }
    },

    created() {
        this.getTags();
    },

    methods: {
        async getCustomers() {
            this.isLoading = true;
            try {
                const response = await api.customers.fetch({
                    ...this.query,
                    ...this.pagination,
                });
                this.customers = response.items;
                this.total = response.total;
            } finally {
                this.isLoading = false;
            }
        },

        isExcluded(name) {
            return this.excludeColumns.includes(name);
        },

        async getTags() {
            this.tags = this.filter_tags = await api.customers.getTags();
            this.filter_tags.forEach((t) => t.selected = true);
        },

        onCopyCustomerCodeSuccess(event) {
            const customer = this.customers.find(c => c.customer_code === event.text);
            this.$toastr.i(this.$t('customers.copyVisibbleSuccess', { name: customer.name }));
        },

        onCopyCustomerCodeError() {
            this.$toastr.e(this.$t('customers.copyVisibbleError'));
        },
        updateItemTags(itemId, tags) {
            const customer = this.customers.find(item => item.id === itemId);
            if (customer) customer.tag_ids = tags;
        }
    }
}
</script>
